import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

function pad(n) { return String(n).padStart(2, "0"); }

export default function TimePicker({ value, onChange }) {
  // value = "HH:MM" 24h
  const [h24, m] = (value || "07:00").split(":").map((v) => parseInt(v, 10));
  const period = h24 >= 12 ? "PM" : "AM";
  const h12 = ((h24 + 11) % 12) + 1;

  const emit = (newH12, newM, newPeriod) => {
    let hh = newH12 % 12;
    if (newPeriod === "PM") hh += 12;
    onChange(`${pad(hh)}:${pad(newM)}`);
  };

  return (
    <div className="grid grid-cols-3 gap-2">
      <Select value={String(h12)} onValueChange={(v) => emit(parseInt(v, 10), m, period)}>
        <SelectTrigger data-testid="time-hour-select" className="rounded-none border-black bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {Array.from({ length: 12 }, (_, i) => i + 1).map((n) => (
            <SelectItem key={n} value={String(n)}>{n}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={pad(m)} onValueChange={(v) => emit(h12, parseInt(v, 10), period)}>
        <SelectTrigger data-testid="time-minute-select" className="rounded-none border-black bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {["00", "15", "30", "45"].map((n) => (
            <SelectItem key={n} value={n}>{n}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={period} onValueChange={(v) => emit(h12, m, v)}>
        <SelectTrigger data-testid="time-period-select" className="rounded-none border-black bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="AM">AM</SelectItem>
          <SelectItem value="PM">PM</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
